import React, { useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X, Anchor } from "lucide-react";
import { NAV } from "@/constants/testIds";

const links = [
  { to: "/", label: "Home", tid: NAV.home, end: true },
  { to: "/about", label: "About", tid: NAV.about },
  { to: "/divisions", label: "Divisions", tid: NAV.divisions },
  { to: "/subsidiaries", label: "Subsidiaries", tid: NAV.subsidiaries },
  { to: "/fleet", label: "Fleet & Assets", tid: NAV.fleet },
  { to: "/careers", label: "Careers", tid: NAV.careers },
  { to: "/contact", label: "Contact / RFQ", tid: NAV.contact },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) return null; // Admin has its own layout

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#060A14]/80 border-b border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex items-center justify-between h-16 lg:h-20">
        <Link to="/" data-testid={NAV.logo} className="flex items-center gap-3 group">
          <div className="w-9 h-9 bg-[#FF5722] flex items-center justify-center">
            <Anchor size={18} strokeWidth={2.5} className="text-white" />
          </div>
          <div className="leading-none">
            <div className="font-display font-black text-white text-[15px] tracking-tight">BILLTECH HOLDINGS</div>
            <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-[#94A3B8] mt-[2px]">Marine &amp; Engineering Group</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.tid}
              className={({ isActive }) =>
                `px-3 py-2 text-[13px] font-medium uppercase tracking-wider transition-colors ${
                  isActive ? "text-[#FF5722]" : "text-white/70 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <NavLink
            to="/admin"
            data-testid={NAV.admin}
            className={({ isActive }) =>
              `ml-2 px-4 py-2 text-[13px] font-bold uppercase tracking-wider border border-white/20 transition-colors ${
                isActive ? "bg-[#FF5722] border-[#FF5722] text-white" : "text-white hover:border-[#FF5722]"
              }`
            }
          >
            Portal
          </NavLink>
        </nav>

        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#060A14]">
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={`${l.tid}-mobile`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm font-medium uppercase tracking-wider border-l-2 ${
                    isActive
                      ? "text-[#FF5722] border-[#FF5722] bg-white/5"
                      : "text-white/70 border-transparent"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <NavLink
              to="/admin"
              data-testid={`${NAV.admin}-mobile`}
              onClick={() => setOpen(false)}
              className="mt-2 px-3 py-3 text-sm font-bold uppercase tracking-wider bg-[#FF5722] text-white text-center"
            >
              Portal
            </NavLink>
          </div>
        </div>
      )}
    </header>
  );
}
